import {queryOptions} from '@tanstack/react-query';
import {type} from 'arktype';
import {AccountId} from '~/entities/operations-fiat';
import {expectEither, HttpClient, useHttpClient} from '~/library/network-facade';

export const SwiftRequisites = type({
    beneficiary_name: 'string',
    beneficiary_address: 'string',
    swift: type('string | null').optional(),
    account: type('string | null').optional(),
});
export type SwiftRequisites = typeof SwiftRequisites.infer;

function fetchSwiftRequisites(http: HttpClient, accountId: AccountId) {
    return http(`v1/accounts/${accountId}/send/banks/fields/swift`).then(
        ...expectEither({
            200: SwiftRequisites,
            400: null,
        })
    );
}

export function useSwiftRequisitesOptions(accountId: AccountId) {
    const http = useHttpClient();
    const {queryKey, queryFn} = queryOptions({
        queryKey: ['v1/accounts/{accountId}/send/banks/fields/swift', accountId],
        queryFn: async ({client, queryKey}) => {
            const res = await fetchSwiftRequisites(http, accountId);
            switch (res.status) {
                case 200:
                    return {value: res.json};
                case 400:
                    return {problem: res.json};
                case 'Abort': {
                    await client.cancelQueries({queryKey});
                    throw res.reason;
                }
            }
        },
    });
    return {queryKey, queryFn};
}
